<template>
  <div class="quota-list-container">
    <TagsCloud
      ref="cloudtage"
      @cloudTages="cloudTages"
    />
    <div class="project-table">
      <avue-crud
        :option="option"
        :data="tableData"
        ref="crud"
        :page.sync="page"
        :search.sync="searchForm"
        v-model="form"
        :before-open="beforeOpenScope"
        @search-reset="searchReset"
        @row-save="rowSave"
        @on-load="queryTableData"
        @search-change="searchChange"
        @sort-change="sortChange"
        @refresh-change="queryTableData"
        @selection-change="selectionChange"
        @row-click="goDetail"
        :table-loading="loading"
      >
        <template slot="searchMenu" slot-scope="{ row }">
          <el-button type="primary" @click="save(row)">保存</el-button>
          <!-- <el-button type="primary" @click="openFilter">
            <a-icon type="filter" /> 高级筛选
          </el-button> -->
        </template>

        <template slot="menuLeft">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-plus"
            v-if="permission.factoringCustomerList_add"
            @click="handleAdd()"
          >
            新增客户</el-button
          >
          <el-dropdown size="small" trigger="click" class="el_dropdown" v-if="permission.factoringCustomerList_edit">
            <el-button type="primary" plain size="small">
              <div v-if="auditList.length > 0" class="el_dropdown_num">
                {{ auditList.length }}
              </div>
              <i class="el-icon-refresh"></i>
              移交
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="addTransfer">
                新增移交
              </el-dropdown-item>
              <el-dropdown-item @click.native="showaApplyDialog">
                我的申请
              </el-dropdown-item>
              <el-dropdown-item @click.native="showAuditDialog">
                我的审核
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            v-if="permission.factoringCustomerList_delete"
            plain
            @click.stop="handleDelete()"
            >删除
          </el-button>
          <el-button size="small" icon="el-icon-download" @click="exportShow"
            >导出数据
          </el-button>
        </template>

        <template slot="custNameT" slot-scope="{ row }">
          <div class="project-name" @click="goDetail(row)">
            {{ row.custName }}
          </div>
        </template>
        <template slot="unifiedSocialCreditCodeLabel" slot-scope="{ row }">
          <span>{{
            form.basicCustType == 2 ? "统一社会信用代码" : "身份证号码"
          }}</span>
        </template>
        <template slot="custNameLabel" slot-scope="{ row }">
          <span>{{ form.basicCustType == 2 ? "客户名称" : "客户姓名" }}</span>
        </template>
        <template slot="custNameForm">
          <el-select
            filterable
            v-model="form.custName"
            placeholder="输入关键字搜索客户"
            value-key="id"
            @change="changeCustName"
          >
            <el-option
              v-for="item in basicList"
              :key="item.id"
              :label="item.custName"
              :value="item"
            >
            </el-option>
          </el-select>
        </template>
      </avue-crud>
    </div>

    <el-drawer
      title="高级筛选"
      :visible.sync="drawer"
      size="60%"
      custom-class="drawer_wrapper"
      :with-header="false"
    >
      <div class="drawer_screen_wrapper">
        <div class="screen_header">
          <div class="screen_header_name">
            <a-icon type="filter" />
            高级筛选
          </div>
          <div class="screen_header_remarks" @click="drawer = false">
            <i class="el-icon-video-play"></i>
            收起
          </div>
        </div>
        <div class="screen_content">
          <avue-form
            :option="filterConfig"
            ref="formScreen"
            v-model="searchForm"
            @submit="filterSearch"
            @reset-change="searchResetScreen"
          >
          </avue-form>
        </div>
      </div>
    </el-drawer>

    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="true"
      :clear="false"
      @setPeople="setPeople"
    />

    <SelectDepartment
      ref="selectdepartment"
      :checkdepartment="checkdepartment"
      :isOnly="true"
      @setDepartment="setDepartment"
    />

    <ExportData ref="exportData" @exportDownload="exportDownload" />
    <el-dialog
      :close-on-click-modal="false" width="40%" title="客户移交" :visible.sync="transferVisible">
      <div>
        <avue-form
          :option="transferConfig"
          ref="transferForm"
          v-model="transferForm"
          @submit="transferSumbit"
          :table-loading="loading"
        >
          <template slot="blCustNamesLabel">
            <span
              >已选择
              <span class="blCustNumber">{{ selectionList.length }}个</span>
              客户</span
            >
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false" width="70%" title="移交申请" :visible.sync="applyVisible">
      <div>
        <avue-crud
          :option="applyConfig"
          :data="applyList"
          ref="applyCrud"
          :page.sync="pageApply"
          :table-loading="loading"
        >
        </avue-crud>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false" width="70%" title="移交审核" :visible.sync="auditVisible">
      <div>
        <avue-crud
          :option="auditConfig"
          :data="auditList"
          ref="auditCrud"
          :page.sync="pageAudit"
          :table-loading="loading"
          @selection-change="selectionAuditChange"
        >
        </avue-crud>
        <div class="audit_button">
          <el-button type="warning" size="small" plain @click="audit(-1)"
            >退回
          </el-button>
          <el-button type="primary" size="small" @click="audit(1)"
            >通过
          </el-button>
        </div>
      </div>
    </el-dialog>
    <Dialogreason
      :passdata="passdata"
      @passcheck="passcheck"
      ref="reasondialog"
    />
  </div>
</template>
<script>
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import ExportData from "@/components/exportData/exportData";
import SelectPerson from "@/components/SelectPersonnel/person";
import SelectDepartment from "@/components/SelectDepartment/department";
import commonList from "@/mixins/list";
import Dialogreason from "@/components/detail/rzzl_lxj/reason";
import {
  customerListConfig,
  filterConfig,
  transferConfig,
  applyConfig,
  auditConfig,
} from "./customerConfig.js";
import {
  getCustomerList,
  submitCustomer,
  transferSubmit,
  myAudit,
  myApply,
  transferAudit,
  deleteCustomer,
} from "@/api/factoring/factoringCustomer";
import { basicInformations } from "@/api/zd/visit";
import { mapGetters } from "vuex";
import { downLoadTemplateGet } from "@/router/downLoadTem";
export default {
  name: "customerList",
  mixins: [commonList],
  data() {
    return {
      drawer: false,
      tableData: [],
      form: {},
      searchForm: {},
      checkUserList: [],
      checkdepartment: [],
      option: customerListConfig(
        this.getMoney,
        this.selectPersonClick,
        this.selectDeptClick
      ),
      filterConfig: filterConfig(this.selectPersonClick, this.selectDeptClick),
      transferConfig: transferConfig(this.selectPersonClick),
      applyConfig: applyConfig(),
      auditConfig: auditConfig(),
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      pageApply: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 999,
      },
      pageAudit: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 999,
      },
      basicList: [], //客户名称 列表
      selectionList: [], //新增移交数组
      transferVisible: false, //移交弹框
      transferForm: {},
      applyVisible: false, //申请弹框
      applyList: [],
      auditVisible: false, //审核弹框
      auditList: [],
      loading: false,
      selectionAuditList: [],
      passdata: {
        id: "",
        auditAdvise: "",
        pass: false,
      },
      tagsCloudVisible: false,
    };
  },
  components: {
    TagsCloud,
    SelectPerson,
    SelectDepartment,
    ExportData,
    Dialogreason,
  },

  computed: {
    ...mapGetters(["userInfo",'permission']),
  },

  mounted() {
    let that = this;

    // window.addEventListener("click", function (e) {
    //   that.$nextTick(() => {
      
    //     let dom = document.getElementsByClassName("avue-crud__search");
    //     // this.tagsCloudVisible = dom[0].clientHeight == 0;
    //   });
    // });

    let setParams = {
      departmentIDKey: "managerDept",
    };
    // this.setCommonParams(setParams);

    // 设置导出链接
    this.setExportUrl("/api/bl/blquota/export");
  },
  methods: {
    //导出数据
    exportShow() {
      this.$refs.exportData.showModel();
    },
    exportDownload(value) {
      let page = this.page;
      let data = {
        export: value.code,
        auditState: 1,
      };
      if (value.code == 1) {
        data = {
          ...data,
          current: page.currentPage,
          size: page.pageSize,
          ...this.searchForm,
        };
      } else if (value.code == 2) {
        data = {
          ...data,
          ...this.searchForm,
        };
      }
      downLoadTemplateGet(
        "/api/bl/custbasicinformationbl/export",
        data
      ).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },
    //确定通过或退回
    passcheck(data) {
      this.auditSubmit(-1, data.auditAdvise);
    },

    //审核操作
    audit(status) {
      if (this.selectionAuditList.length == 1) {
        if (status == 1) {
          this.auditSubmit(status);
        } else {
          this.$refs.reasondialog.showblock();
        }
      } else if (this.selectionAuditList.length > 1) {
        this.$message.error("只能选择一条数据进行操作");
      } else {
        this.$message.error("请选择一条数据进行操作");
      }
    },
    //审核操作
    auditSubmit(status, auditRemark) {
      this.loading = true;

      let data = {
        id: this.selectionAuditList
          .map((item) => {
            return item.id;
          })
          .join(","),
        auditRemark: auditRemark,
        status,
      };

      transferAudit(data).then(
        (res) => {
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "操作成功!",
            });
            this.showAuditDialog();
          } else {
            this.$message.error(res.data.msg);
            this.loading = false;
          }
        },
        (error) => {
          // done();
          this.loading = false;
          window.console.log(error);
        }
      );
    },
    //选择项发生变化 传入数组
    selectionChange(list) {
      this.selectionList = list;
    },

    //审核勾选传入数组
    selectionAuditChange(list) {
      this.selectionAuditList = list;
    },
    //打开移交弹窗
    addTransfer() {
      if (this.selectionList.length > 0) {
        

        let filterList = this.selectionList.filter((item) => {
          return this.userInfo.user_id != item.managerUser;
        });

        let isTransferAuditList = this.selectionList.filter((item) => {
          return  item.isTransferAudit==1;
        });
        if (filterList.length > 0) {
          this.$message.error("只能勾选本人负责的客户数据");
        } 
        else if (isTransferAuditList.length > 0) {
          this.$message.error("只能勾选未移交的客户数据");
        } else {
          this.transferForm.blCustNames = this.selectionList
            .map((item) => {
              return item.custName;
            })
            .join(",");
          this.transferVisible = true;
        }
        // let data = this.selectionList[0];
        // this.$refs.crud.rowEdit(data);
      } else {
        this.$message.error("请选择一条数据进行操作");
      }
    },

    //搜索
    searchChange(params, done) {
      this.searchForm = {...this.searchForm,...params};
      this.searchForm.custName = params.custNameT;
      this.page.currentPage = 1;
      this.queryTableData();
      done();
    },
    //清空
    searchReset() {
      // if (this.cloudStatus) {
      //   this.cloudStatus = false;
      //   return;
      // }
      this.searchForm = {};
      this.checkUserList = [];
      this.queryTableData();
    },
    save(row) {
      this.$refs.cloudtage.save(row);
    },
    //常用查询
    cloudTages(data) {
      // this.cloudStatus = true;
      // this.$refs.crud.searchReset();
      // this.form = data;
      // this.searchChange(data);
      this.searchForm = data
    },
    beforeOpenScope(done, type) {
      let that = this;
      that.basicInformations();
      if (["add"].includes(type)) {
        this.$nextTick(() => {
          that.form.basicCustType = 1;
        });
      }
      if (["edit", "view"].includes(type)) {
        console.log();
      }
      done();
    },
    //新增
    handleAdd() {
      this.$refs.crud.rowAdd();
    },
    //新增
    rowSave(row, done, loading) {
      let data = {
        basicCustType: this.form.basicCustType,

        custShortName: this.form.custShortName,
        basicId: this.form.id,
      };
      submitCustomer(data).then(
        () => {
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          // 数据回调进行刷新
          done(row);
          this.queryTableData();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    // 跳转详情
    goDetail(row) {
      if(!this.permission.factoringCustomerList_view){
        this.$message.error("没有查看权限");
        return
      }
      this.$router.push({
        path: `/factoring/customerManage/customerDetail/${row.id}`,
      });
    },
    // 删除
    handleDelete() {
      let self = this;
      if (this.selectionList.length > 1) {
        this.$message.error("只能选择一条数据进行删除");
      } else if (this.selectionList.length == 1) {
        if(this.selectionList[0].managerUser == this.userInfo.user_id){
          this.$confirm("确定删除选择的数据?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(async () => {
              let ids = this.selectionList.map((item) => {
                return item.id;
              });
              let res = await deleteCustomer({ ids: ids.join(",") });
              if (res.data.code == 200) {
                self.$message({
                  type: "success",
                  message: "删除成功",
                });
                self.queryTableData();
              }
            })
            .catch(() => {
              self.$message({
                type: "info",
                message: "已取消删除",
              });
            });
        }else {
          this.$message.warning('您没有权限删除此条数据')
        }

      } else {
        this.$message.error("请选择数据进行删除");
      }
    },
    //获取列表
    async queryTableData() {
      this.loading = true;
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchForm,
      };
      let res = await getCustomerList(params);
      if (res.data.code == 200) {
        this.tableData = res.data.data.records;
        this.page.total = res.data.data.total;
        this.loading = false;
      } else {
        this.$message.error(res.data.msg);
        this.loading = false;
      }
    },
    //我的申请 弹框
    showaApplyDialog() {
      this.loading = true;
      this.applyVisible = true;
      this.getMyApply();
    },

    //我的审核 弹框
    showAuditDialog() {
      this.loading = true;
      this.auditVisible = true;
      this.getMyAudit();
    },
    // 获取我的申请列表
    async getMyApply() {
      let params = {
        current: this.pageApply.currentPage,
        size: this.pageApply.pageSize,
      };
      let res = await myApply(params);
      if (res.data.code == 200) {
        this.applyList = res.data.data;
        this.pageApply.total = res.data.data.length;
        this.loading = false;
      } else {
        this.$message.error(res.data.msg);
        this.loading = false;
      }
    },

    // 获取我的审核列表
    async getMyAudit() {
      let params = {
        current: this.pageAudit.currentPage,
        size: this.pageAudit.pageSize,
      };
      let res = await myAudit(params);
      if (res.data.code == 200) {
        this.auditList = res.data.data;
        this.pageAudit.total = res.data.data.length;
        this.loading = false;
      } else {
        this.$message.error(res.data.msg);
        this.loading = false;
      }
    },
    //客户名称列表
    basicInformations() {
      basicInformations({}).then((res) => {
        this.basicList = res.data.data;
      });
    },
    //选择了客户名称 的各种数据回填
    changeCustName(data) {
      this.form.custName = data.custName;
      this.form.id = data.id;
      this.form.unifiedSocialCreditCode = data.unifiedSocialCreditCode;
    },
    // 人员选择插件打开
    selectPersonClick(name) {
      this.personCk = name;
      this.$refs.selectperson.showmode();
    },
    //人员 获取
    setPeople(val) {
      let people = val.map((item) => {
        return item.realName;
      });
      let ids = val.map((item) => {
        return item.id;
      });
      if (this.personCk == "receiveUser") {
        this.transferForm.receiveUser = people.join(",");
        this.transferForm.receiveUserId = ids.join(",");
      } else {
        this.searchForm.businessManage = people.join(",");
        this.searchForm.managerUser = ids.join(",");
      }
    },
    searchResetScreen() {
      this.searchForm = {};
      this.page.currentPage = 1;
      this.queryTableData();
    },
    filterSearch(str, done) {
      this.page.currentPage = 1;
      this.queryTableData();
      this.drawer = false;
      done();
    },
    transferSumbit(row, done, loading) {
      let self = this;

      this.$refs.transferForm.validate((vaild) => {
        if (vaild) {
          let data = {
            blCustIds: this.selectionList
              .map((item) => {
                return item.id;
              })
              .join(","),

            receiveUserId: self.transferForm.receiveUserId,
            reason: self.transferForm.reason,
            status: 0,
          };

          transferSubmit(data).then(
            (res) => {
              self.$message({
                type: "success",
                message: "操作成功!",
              });
              done();
              self.transferForm = {};
              this.$refs.transferForm.resetForm();
              self.transferVisible = false;
            },
            (error) => {
              window.console.log(error);
              loading();
            }
          );
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.quota-list-container {
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .project-table {
    background: #ffff;
    padding: 25px;
  }
  .project-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #409eff;
  }
  .project-name:hover {
    color: #409eff;
    cursor: pointer;
  }
  .quota-status {
    position: relative;
    padding-left: 20px;
  }
  .quota-status::before {
    position: absolute;
    content: "";
    background-color: #19b16b;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    left: 12px;
    top: 7px;
  }
  .red-point::before {
    color: #f56c6c !important;
  }
}
.blCustNumber {
  font-weight: 700;
  color: #409eff;
  font-size: 13px;
}
/deep/ .el-dialog__body .avue-crud__menu {
  display: none;
}
.audit_button {
  display: flex;
  margin-top: 20px;
  justify-content: flex-end;
}
.el_dropdown {
  position: relative;
  .el_dropdown_num {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 0;
    top: -10px;
    width: 20px;
    height: 20px;
    font-size: 12px;
    color: #ffffff;
    background-color: rgba(245, 108, 108, 1);
    border-radius: 50%;
    z-index: 99;
  }
}
/deep/.avue-crud__menu {
  padding-top: 10px;
}
</style>